import React, { useState, useEffect } from "react";
import { Grid, Menu, Container, Responsive, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import "./styles.css";
//Redux
import { loadUser } from "../../redux/actions/auth";
// Components
import AccountDetails from "./components/AccountDetails/AccountDetails";
import AccountHeader from "./components/AccountHeader";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import AccountHistory from "./components/AccountHistory/AccountHistory";
import WishList from "./components/Wishlist";
import MyAddresses from "./components/MyAddresses";

const Account = (props) => {
  const [state, setState] = useState({ activeItem: "MI CUENTA", event: null });
  const [provider, setProvider] = useState("");

  const { activeItem } = state;
  const { loadUser, authentication, auth } = props;
  const profile = auth.profile;
  const { isLoaded } = authentication;

  useEffect(() => {
    if (isLoaded) {
      loadUser(authentication);
    }
  }, [isLoaded, loadUser, authentication]);

  useEffect(() => {
    if (!auth.loading) {
      setProvider(auth.user.providerData[0].providerId);
    }
  }, [auth]);

  const handleItemClick = (e, { name }) =>
    setState((prevState) => ({ ...prevState, activeItem: name }));

  const eventAccount = (activeItem) => {
    switch (activeItem) {
      case "EDITAR PERFIL":
        return <AccountDetails authentication={authentication} />;
      case "CAMBIAR CONTRASEÑA":
        return <ChangePassword />;
      case "WISHLIST":
        return <WishList />;
      case "HISTORIAL DE COMPRAS":
        return <AccountHistory auth={auth} />;
      case "MIS DIRECCIONES":
        return <MyAddresses />;
      default:
        return <AccountHeader auth={auth} profile={profile} />;
    }
  };
  return !props.auth.loading ? (
    <div className="container-Sections">
      <Container className="account-container">
        <div style={styles.containerWelcome}>
          <h4 className="text-center">
            Hola {profile.name} {profile.lastName}
          </h4>
          <p className="text-center">Bienvenido a La Floristería Honduras</p>
        </div>
        <Responsive minWidth={769}>
          <Grid>
            <Grid.Column width={4}>
              <Menu fluid vertical tabular>
                <Menu.Item
                  name="MI CUENTA"
                  active={activeItem === "MI CUENTA"}
                  onClick={handleItemClick}
                />
                <Menu.Item
                  name="EDITAR PERFIL"
                  active={activeItem === "EDITAR PERFIL"}
                  onClick={handleItemClick}
                />
                <Menu.Item
                  name="MIS DIRECCIONES"
                  active={activeItem === "MIS DIRECCIONES"}
                  onClick={handleItemClick}
                />
                {provider === "password" ? (
                  <Menu.Item
                    name="CAMBIAR CONTRASEÑA"
                    active={activeItem === "CAMBIAR CONTRASEÑA"}
                    onClick={handleItemClick}
                  />
                ) : null}
                <Menu.Item
                  name="WISHLIST"
                  active={activeItem === "WISHLIST"}
                  onClick={handleItemClick}
                />
                <Menu.Item
                  name="HISTORIAL DE COMPRAS"
                  active={activeItem === "HISTORIAL DE COMPRAS"}
                  onClick={handleItemClick}
                />
              </Menu>
            </Grid.Column>

            <Grid.Column stretched width={12}>
              {eventAccount(state.activeItem)}
            </Grid.Column>
          </Grid>
        </Responsive>
        <Responsive maxWidth={768}>
          <Menu fluid stackable>
            <Menu.Item
              name="MI CUENTA"
              active={activeItem === "MI CUENTA"}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="EDITAR PERFIL"
              active={activeItem === "EDITAR PERFIL"}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="MIS DIRECCIONES"
              active={activeItem === "MIS DIRECCIONES"}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="CAMBIAR CONTRASEÑA"
              active={activeItem === "CAMBIAR CONTRASEÑA"}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="WISHLIST"
              active={activeItem === "WISHLIST"}
              onClick={handleItemClick}
            />
            <Menu.Item
              name="HISTORIAL DE COMPRAS"
              active={activeItem === "HISTORIAL DE COMPRAS"}
              onClick={handleItemClick}
            />
          </Menu>

          {eventAccount(state.activeItem)}
        </Responsive>
      </Container>
    </div>
  ) : (
    <div className="container-Sections">
      <div className="loader-container">
        <Loader
          style={{ alignSelf: "center" }}
          size="large"
          inline="centered"
          active
        />
      </div>
    </div>
  );
};
const styles = {
  containerWelcome: {
    backgroundColor: "#F0F0F0",
    paddingTop: "2rem",
    paddingBottom: "2rem",
  },
};
const mapStateToProps = ({ firebase, auth }) => ({
  authentication: firebase.auth,
  profile: firebase.profile,
  auth,
});

export default connect(mapStateToProps, { loadUser })(Account);
